<template>
  <div class="user_info_form register_agree">
    <h4 class="access_hidden">이용약관 동의</h4>
    <!--    <div class="agree all">-->
    <!--      <check-box @custom-checked="handleCheck()" :checked="agreeCheckAll" id="agree" text="전체 동의하기" />-->
    <!--    </div>-->
    <div class="agree">
      <check-box
        @custom-checked="handleCheck(1)"
        :checked="agreeCheck1"
        id="agree1"
        text="개인정보 수집 및 이용 동의"
      />
      <v-button
        class="btn_open"
        @handleClick="agreeLayerChange(1)"
        text="개인정보 수집 및 이용 동의 내용 보기"
        :textHide="true"
      />
    </div>
    <template v-if="userInfo.businessType === 0">
    <!--  일반 개인 등록시에는 주민번호 없어서 안내 불필요  -->
      <div></div>
    </template>
    <!--    개인사업자/법인사업자에서 개인 변경시에는 주민번호 입력 필요하여 개인정보 수집 및 이용안내 추가 -->
    <template v-else-if="userInfo.businessType === 2 || userInfo.businessType === 3 || !userInfo.isCheckedIdNo">
      <div class="hr"></div>
      <div class="agree">
        <v-icon clsName="icon_agree" />
        개인정보 수집 및 이용 안내
        <v-button
          class="btn_open"
          @handleClick="agreeLayerChange(3)"
          text="개인정보 수집 및 이용 안내"
          :textHide="true"
        />
      </div>
    </template>
    <agree-layer @custom-change="agreeLayerChange(0)" :state="agreeLayer" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import CheckBox from '@/components/atoms/CheckBox';
import VButton from '@/components/atoms/VButton';
import VIcon from '@/components/atoms/VIcon';
import AgreeLayer from '@/components/modules/common/AgreeLayer';

export default {
  components: {
    CheckBox,
    VButton,
    VIcon,
    AgreeLayer,
  },
  data() {
    return {
      agreeCheck1: false,
      agreeCheck2: false,
      agreeLayer: 0,
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    agreeCheckAll() {
      // return this.agreeCheck1 === true && this.agreeCheck2 === true;
      return this.agreeCheck1 === true;
    },
  },
  methods: {
    agreeLayerChange(val) {
      this.agreeLayer = val;
    },
    handleCheck(val) {
      if (val === 1) {
        this.agreeCheck1 = !this.agreeCheck1;
      } else if (val === 2) {
        this.agreeCheck2 = !this.agreeCheck2;
      } else {
        if (this.agreeCheckAll) {
          this.agreeCheck1 = false;
          this.agreeCheck2 = false;
        } else {
          this.agreeCheck1 = true;
          this.agreeCheck2 = true;
        }
      }
      this.$emit('update', { isState: this.agreeCheckAll });
    },
  },
};
</script>
<style lang="scss">
.hr {
  border-top: 1px solid #efefef;
  margin: 20px 0;
}
</style>
